import { ModalView, useModalView } from '@/design-system/components/modal';
import { NativeModalView } from '@/design-system/components/modal/nativeModal/NativeModalView';
import { useNativeModalView } from '@/design-system/components/modal/nativeModal/useNativeModalView';
import { LayoutContext } from 'contexts/LayoutContext';
import { useContext } from 'react';
import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';
import { SxProp } from 'dripsy';

interface ModalContainerViewProps {
  dimensions: {
    height: number;
    width: number;
  };
  nativeFlag?: boolean;
  overflow?: 'visible' | 'hidden';
  sx?: SxProp;
  marginTop?: number;
}

export const ModalContainerView: React.FC<ModalContainerViewProps> = ({
  dimensions,
  children,
  nativeFlag = { default: true },
  overflow,
  sx,
  marginTop
}) => {
  const layout = useContext(LayoutContext);

  if (layout.isMobile) {
    if (nativeFlag) {
      const { animatedStyle, handleBack } = useNativeModalView({});
      return (
        <NativeModalView animatedStyle={animatedStyle} onBack={handleBack} showHeader={false}>
          <UtxAppEmbed>{children}</UtxAppEmbed>
        </NativeModalView>
      );
    } else {
      return <UtxAppEmbed>{children}</UtxAppEmbed>;
    }
  }

  const modal = useModalView({ dimensions });

  return (
    <ModalView sx={sx} marginTop={marginTop} overflow={overflow} {...modal}>
      {children}
    </ModalView>
  );
};
